import { styled } from '@mui/material/styles';
import * as React from 'react';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const HtmlTooltipStyled = styled(({ className, placement = 'top', ...props }) => (
    <Tooltip placement={placement} {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black1e,
        borderRadius: '16px',
        padding: '16px',
    },
}));
export default function HtmlTooltip({ children, title, text, style, placement }) {
    return (
        <HtmlTooltipStyled
            placement={placement}
            title={
                title || (
                    <React.Fragment>
                        <Typography style={{ opacity: 0.8, color: 'white', fontSize: '12px', ...style }}>
                            {text}
                        </Typography>
                    </React.Fragment>
                )
            }
        >
            <div style={style}>{children}</div>
        </HtmlTooltipStyled>
    );
}
